// Moves the chat with `schannelId` to the top of a chat list (newest
// activity first), optionally updating it on the way (QA CM-06).
// Returns the same array when the chat isn't there, so it is safe to use
// inside a state updater: React then skips the re-render.
export const moveChatToFront = (list, schannelId, update) => {
  if (!Array.isArray(list) || !list.length || schannelId == null) return list;
  const idx = list.findIndex(
    (chat) => chat && String(chat.Team_Channel_Id) === String(schannelId)
  );
  if (idx === -1) return list;
  if (idx === 0 && !update) return list;
  const chat = update ? update(list[idx]) : list[idx];
  return [chat, ...list.slice(0, idx), ...list.slice(idx + 1)];
};

export default moveChatToFront;
